import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFlagUsaGlyph from './svgs/FlagUsaGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var flagUsaGlyph = (props => useIcon(SvgFlagUsaGlyph, SvgFlagUsaGlyph, props));

export { flagUsaGlyph as default };
